import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Carousel from 'nuka-carousel';
import './infographic.css'
import { sendEvent } from '../../helpers/analytics'


class InfoGraphic extends Component {
  tabClick = () => {
    sendEvent('infographic','click','ring')
  }
  render () {
    return (
      <div className="infographic">
        <div className="facts">
          <h2>Цифры и факты</h2>
          <p><b>Porsche Sport Challenge 2018: главное о сезоне - в инфографике.</b></p>
          <p>Гоночный сезон 2018 года завершён. Мы приводим основные цифры и факты, которые вы должны знать о шести этапах: кто участвовал, где гонялись и сколько резины сожгли.</p>
        </div>

        <div className="infographic__row tabs_and_slider">
          <div className="infographic__tabs">
            <Tabs>
              <TabList>
                <Tab>
                  <span onClick={this.tabClick}>Moscow Raceway</span>
                </Tab>
                <Tab>
                  <span onClick={this.tabClick}>N-Ring</span>
                </Tab>
                <Tab>
                  <span onClick={this.tabClick}>Kazan-Ring</span>
                </Tab>
                <Tab>
                  <span onClick={this.tabClick}>«Смоленское кольцо»</span>
                </Tab>
              </TabList>

              <TabPanel>
                <div className="tab__block tab__block--1">
                  <div className="bubble">
                    <div>Место: Московская область</div>
                    <div>Длина: (max) 4070 м</div>
                    <div>Ширина: 12-21 м</div>
                    <div>Перепад высот: 33 м</div>
                  </div>
                  <img src="/images/info/moscow_raceaway.png" alt="moscow_raceaway" />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="tab__block  tab__block--2">
                  <div className="bubble">
                    <div>Место: Нижний Новгород (область)</div>
                    <div>Длина: (max) 3222 м</div>
                    <div>Ширина: 12-16 м</div>
                    <div>Перепад высот: 9,6 м</div>
                  </div>
                  <img src="/images/info/n-ring.png" alt="n-ring" />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="tab__block  tab__block--3">
                  <div className="bubble">
                    <div>Место: Казань</div>
                    <div>Длина: (max) 3476 м</div>
                    <div>Ширина: 12-15 м</div>
                    <div>Перепад высот: 28 м</div>
                  </div>
                  <img src="/images/info/kazan-ring.png" alt="kazan-ring" />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="tab__block  tab__block--4">
                  <img src="/images/info/smolenskoe.png" alt="smolenskoe" />
                  <div className="bubble">
                    <div>Место: Смоленская область</div>
                    <div>Длина: (max) 3357 м</div>
                    <div>Ширина: 12-15 м</div>
                    <div>Перепад высот: 18 м </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>

          <div className="infographic__slider">
            <Carousel
              wrapAround={true}
              renderBottomCenterControls={() => null}
              renderCenterLeftControls={({ previousSlide }) => (
                <button className="i-slider__btn i-slider__prev" onClick={() => {previousSlide(); sendEvent('infographic', 'click', 'car')}}></button>
              )}
              renderCenterRightControls={({ nextSlide }) => (
                <button className="i-slider__btn i-slider__next" onClick={() => {nextSlide(); sendEvent('infographic', 'click', 'car')}}></button>
              )}
            >
              <div className="info_slide">
                <div className="slide__title">718 Cayman S</div>
                <div className="slide__image">
                  <img src="/images/info/cayman.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>285 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>4,6 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>350 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">911 GT3 (991)</div>
                <div className="slide__image">
                  <img src="/images/info/911_gt3.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>315 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>3,5 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>475 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">911 GT3RS (991)</div>
                <div className="slide__image">
                  <img src="/images/info/911_gt3rs.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>310 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>3,3 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>500 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">718 Cayman GTS</div>
                <div className="slide__image">
                  <img src="/images/info/718_cayman_gts.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>290 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>4,6 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>365 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">718 Boxster S</div>
                <div className="slide__image">
                  <img src="/images/info/718_boxter_s.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>285 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>4,6 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>350 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">911 Carrera S</div>
                <div className="slide__image">
                  <img src="/images/info/911_carrera_s.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>225 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>8 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>160 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">911 Carrera 4S Coupé</div>
                <div className="slide__image">
                  <img src="/images/info/911_carrera_4s_coupe.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>305 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>4,2 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>420 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">911 Turbo Coupé</div>
                <div className="slide__image">
                  <img src="/images/info/911_turbo_coupe.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>330 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>2,9 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>580 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">porsche 930</div>
                <div className="slide__image">
                  <img src="/images/info/porshe_930.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>260 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>5 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>282 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">cayman GT4</div>
                <div className="slide__image">
                  <img src="/images/info/cayman_gt4.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>295 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>4,4 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>385 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">porsche 993</div>
                <div className="slide__image">
                  <img src="/images/info/porshe_993.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>290 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>4,5 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>402 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">porsche 944</div>
                <div className="slide__image">
                  <img src="/images/info/porshe_944.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>250 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>8,3 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>163 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">porsche 924</div>
                <div className="slide__image">
                  <img src="/images/info/porshe_924.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>204 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>9,6 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>125 л.с</b></span>
                  </div>
                </div>
              </div>

              <div className="info_slide">
                <div className="slide__title">911 Turbo S</div>
                <div className="slide__image">
                  <img src="/images/info/911_turbo_s.png" alt="" />
                </div>
                <div className="slide__info">
                  <div className="car_stat">
                    <div className="car_stat__icon speed" />
                    <span className="car_stat__text"><b>330 км/ч</b> (max)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon stopwatch" />
                    <span className="car_stat__text"><b>2,9 с</b> (0-100 км/ч)</span>
                  </div>
                  <div className="car_stat">
                    <div className="car_stat__icon horsepower" />
                    <span className="car_stat__text"><b>580 л.с</b></span>
                  </div>
                </div>
              </div>
            </Carousel>

          </div>
        </div>

        <div className="infographic__bottom">
          <div className="infographic__item -drivers">
            <div className="i-item__text">гонщиков</div>
            <div className="i-item__number">40</div>
            <div className="i-item__text">за сезон</div>
          </div>

          <div className="infographic__item -fans">
            <div className="i-item__text">болельщиков</div>
            <div className="i-item__number">3000</div>
            <div className="i-item__text">на семи этапах</div>
          </div>

          <div className="infographic__item -tires">
            <div className="i-item__text">комплектов</div>
            <div className="i-item__number">640</div>
            <div className="i-item__text">шин</div>
          </div>

          <div className="infographic__item -disks">
            <div className="i-item__text">тормозных</div>
            <div className="i-item__number">408</div>
            <div className="i-item__text">дисков</div>
          </div>

          <div className="infographic__item -brakes">
            <div className="i-item__text">комплектов</div>
            <div className="i-item__number">816</div>
            <div className="i-item__text">колодок</div>
          </div>

          <div className="infographic__item -gasoline">
            <div className="i-item__text">литров</div>
            <div className="i-item__number">25 345</div>
            <div className="i-item__text">бензина</div>
          </div>

        </div>
      </div>
    )
  }
}

export default InfoGraphic


// WEBPACK FOOTER //
// ./src/pages/infographic/infographic.js